import Vue from 'vue';

export default {
  state: {
    agencies: [],
  },
  getters: {
    agencies(state) {
      return state.agencies;
    },
    // eslint-disable-next-line
    agency: state => (id) => {
      return state.agencies.find(type => type.id === id) || {};
    },
  },
  mutations: {
    SET_AGENCIES(state, payload) {
      state.agencies = payload;
    },
  },
  actions: {
    GET_ANGENCIES(context) {
      return Vue.axios.get('filters/agencies').then((response) => {
        context.commit('SET_AGENCIES', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/agencies.js